import { render } from "./ProprietiesView.vue?vue&type=template&id=466fba72&scoped=true"
import script from "./ProprietiesView.vue?vue&type=script&lang=js"
export * from "./ProprietiesView.vue?vue&type=script&lang=js"

import "./ProprietiesView.vue?vue&type=style&index=0&id=466fba72&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-466fba72"]])

export default __exports__